import type { ComponentProps } from 'react';
import {
  Tabs as DsTabs,
  TabsContent as DsTabsContent,
  TabsList as DsTabsList,
  TabsTrigger as DsTabsTrigger,
} from '@repo/design-system/components/ui/v2/tab-navigation';
import { cn } from '../../lib/utils.ts';

/**
 * The CRM's Tabs: the design system's v2 Tab Navigation (TS-1681, underlined tabs), copied
 * from Hriq. Same Radix API as before. The list scrolls sideways when the tabs outgrow it (the
 * candidate page on a phone) instead of pushing the page wider.
 */
export const Tabs = DsTabs;
export const TabsTrigger = DsTabsTrigger;

export function TabsList({ className, ...props }: ComponentProps<typeof DsTabsList>) {
  return (
    <DsTabsList
      className={cn('max-w-full overflow-x-auto [scrollbar-width:none]', className)}
      {...props}
    />
  );
}

export function TabsContent({ className, ...props }: ComponentProps<typeof DsTabsContent>) {
  return <DsTabsContent className={cn('mt-3', className)} {...props} />;
}
